import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import acesso from "./services";

interface IRequestGetAtivarAcesso {
  login: string;
  email: string;
  key: string;
  pass: string;
}

interface IStateAtivarAcesso {
  status: "idle" | "loading" | "success" | "error";
  error: string | null;
}

const initialState: IStateAtivarAcesso = {
  status: "idle",
  error: null,
};

export const actionGetAtivarAcesso = createAsyncThunk<
  any,
  IRequestGetAtivarAcesso,
  { rejectValue: string }
>("ativarAcesso/actionGetAtivarAcesso", async (params, { rejectWithValue }) => {
  try {
    const data = await acesso(params);
    return data;
  } catch (err: any) {
    const errorMessage = err.message || "Falha ao processar a solicitação.";
    return rejectWithValue(errorMessage);
  }
});

const ativarAcessoSlice = createSlice({
  name: "ativarAcesso",
  initialState,
  reducers: {
    resetAtivarAcessoState: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionGetAtivarAcesso.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(actionGetAtivarAcesso.fulfilled, (state) => {
        state.status = "success";
      })
      .addCase(
        actionGetAtivarAcesso.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload || "Ocorreu um erro desconhecido.";
        }
      );
  },
});

export const { resetAtivarAcessoState } = ativarAcessoSlice.actions;
export default ativarAcessoSlice.reducer;
